/**
 * The speed stat over flight results (src/components/search/SearchSpeedStat.jsx):
 * how long this search took, from pressing Search to the first flights on
 * screen — the same `ms_first` the search_results event logs.
 *
 * Shown only when it's fast enough to be worth showing: a stopwatch
 * celebrating eight seconds isn't. Under a tenth of a second (the search
 * was ready when they pressed it) it reads "Instant", not "0.00s".
 */
export const SPEED_STAT_MAX_MS = 3000;
export const SPEED_STAT_INSTANT_MS = 100;

/** What the stat says for a search that took `ms`, or null to show nothing. */
export function speedStatView(ms) {
  const n = Number(ms);
  if (ms == null || !Number.isFinite(n) || n < 0 || n > SPEED_STAT_MAX_MS) return null;
  if (n < SPEED_STAT_INSTANT_MS) return { instant: true, seconds: null };
  return { instant: false, seconds: (n / 1000).toFixed(2) };
}
